module.exports = __webpack_public_path__ + "static/dexTradeSmall-57d77cef06a84d7ece588922cde98b8a.svg";